import { WebsocketController } from "Controllers";

export class ArticleApplicationController {

    public async predictTechnology(websocketController: WebsocketController, caseId: number, documentId: string, documentType: number, 
            action: string, dobject: string, modelType: string | undefined | null): Promise<void> {
        if(!modelType) modelType = "original_performance";
        if(modelType === "general") modelType = "original_performance";
        await websocketController.invokeFunction("StartTechnologyPrediction", caseId, documentId, documentType, action, dobject, modelType);
    }

    public async findUsedUnits(websocketController: WebsocketController, caseId: number, documentId: string, documentType: number, queryId: string) {
        await websocketController.invokeFunction("StartUnitPrediction", documentId, documentType, caseId, queryId);
    }
}

export const ArticleApplicationControllerSingleton = new ArticleApplicationController(); 